import {
  DesignChannelType,
  DesignNoInputTimeoutOverride
} from '../../../types';

export function normalizeNoInputTimeoutOverride(
  itemWithOverride: {
    noInputTimeoutOverride?: DesignNoInputTimeoutOverride;
  },
  defaultTimeout: null | number | string | undefined
): void {
  let { noInputTimeoutOverride } = itemWithOverride;
  if (noInputTimeoutOverride) {
    return;
  }

  noInputTimeoutOverride = {};
  defaultTimeout = (defaultTimeout) ? Number(defaultTimeout) : null;
  if (defaultTimeout) {
    noInputTimeoutOverride[DesignChannelType.voice] = defaultTimeout;
  }

  itemWithOverride.noInputTimeoutOverride = noInputTimeoutOverride;
}
